import axios from "axios";
import API from "../../constants/APIConstant";
export default
    {
        getLanguagePaginated(filter) {
            return axios.post(API.LANGUAGE_LIST, filter);
        },
        addLanguage(model) {
            return axios.post(API.ADD_LANGUAGE, model);
        },
        updateLanguage(model) {
            return axios.post(API.UPDATE_LANGUAGE, model);

        }
    }